import { Component, OnInit } from '@angular/core';

import {environment} from '../../../../../environments/environment';
import { AuthRESTService } from "../../../services/rest/auth-rest.service";
import { HeaderWidget } from "../../../widgets/header/header.component";
import _ from 'lodash'
import { ActivatedRoute, Router } from '@angular/router';
import Commons from 'app/components/pages/commons';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MetaPropertySchema } from '../../../../models/metaPropertySchema';
import { SharedModule } from 'app/shared.module';
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { debounceTime } from 'rxjs/operators'

@Component({
  standalone: true,
  imports: [SharedModule, AppWidgetModule],
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.css']
})
export class UsersPage extends Commons implements OnInit {
    users: Array<any> = [];
    usersPerPage: number;
    userToDelete: string;
    reasonForDeletion: string;
    firstUserOnFirstPage: any;
    lastUser: any;
    firstUser: any;
    router: Router;
    showBackButton: boolean = true;
    showNextButton: boolean = true;
    homeLink: string;
    backLink: string;
	forwardLink: string;
	currentState:  string = "initial" //"loading", "initial", "loaded"
	propNamesToReturn: string[] = [
		"primary_email", "username", "first_name", "name"
	];
	propsToReturn: Array<MetaPropertySchema> = []; // gets inflated by propNamesToReturn
	propNamesToSearch: string[] = ["primary_email", "username", "first_name", "name"];
	propsToSearch: Array<MetaPropertySchema> = []; // gets inflated by propNamesToSearch
	params: any = {
		searchTerm: '',
		itemsOnPage: 10,
		nrPage: 1,
		propertyIdsToSearch: null,
		propertiesToReturn: [],
		asc: true
	};
	pages: number [] = [];
	totalResultItemsCount: number = 0;
	minCharactersToStartSearch: number = 4;

    constructor(private rest: AuthRESTService, private route: ActivatedRoute,
        toastr: ToastrService, translate: TranslateService, router: Router) {
        super(toastr, translate)
        this.rest = rest;
		this.router = router;
		if (!environment.systemCode) return;
		if (environment.systemCode === "SV") {
			this.propNamesToReturn.push("NIT", "DUI");
			this.propNamesToSearch.push("NIT", "DUI");
		}
		if (environment.systemCode === "GT") {
			this.propNamesToReturn.push("NIT", "DPI");
			this.propNamesToSearch.push("NIT", "DPI");
		}
    }

    userVerificationMessage(user) {
        return HeaderWidget.getVerificationMessage(user.userVerified, user.emailVerified)
    }

    showVerificationWarning(user) {
        return HeaderWidget.showVerificationWarning(user.userVerified, user.emailVerified)
    }


	getUsers() {
		this.route.paramMap.pipe(debounceTime(1000)).subscribe(params => {
			let searchTerm = params.get('searchTerm');

			this.params.searchTerm = searchTerm || '';
			this.params.propertyIdsToSearch = this.propsToSearch.map((prop) => { return prop.id; });
			if (!searchTerm) {
				this.currentState = "initial";
				this.users = [];
				return;
			}
			if (searchTerm.length < this.minCharactersToStartSearch) return;
			this.currentState = "loading";
			this.rest.post('manager/userList', this.params).subscribe((response) => {
				this.currentState = "loaded";
				this.totalResultItemsCount = response.count;
				this.users = [];
				response.users.forEach((userData) => {
					let result = {
						id: userData.id,
						userVerified: userData.verified,
						values: []
					};
					this.propsToReturn.forEach((prop) => {
						if (!userData.properties.some((userProp) => {
							if (userProp.id === prop.id) {
								result.values.push(userProp.values[0].value);
								return true;
							}
						})) {
							result.values.push("-");
						}
					});
					this.users.push(result);
				});
			}, err => {
				this.errorHandler(err);
				this.currentState = "loaded";
			});
		});
	}

    ngOnInit() {
		this.rest.get('cas/configuration/property').subscribe((response) => {
			response.forEach((prop) => {
				this.propNamesToReturn.forEach((propName, idx) => {
					if (propName === prop.name) {
						this.propsToReturn[idx] = Object.assign(new MetaPropertySchema(), prop, { display: (prop.display && JSON.parse(prop.display)) });
						this.params.propertiesToReturn.push(prop.id);
					}
				});
				this.propNamesToSearch.forEach((propName, idx) => {
					if (propName === prop.name) {
						this.propsToSearch[idx] = Object.assign(new MetaPropertySchema(), prop, { display: (prop.display && JSON.parse(prop.display)) });
					}
				});
			});

			this.getUsers();
		});
    }


    convertToDateTime(isoDate: string) {
        return new Date(isoDate).toLocaleString()
	}

	setParam(paramName: any, event: any) {
		this.params[paramName] = event.target.value;
		this.updateRoute();
	}

	updateRoute() {
		this.router.navigate(['users',  Object.assign({}, this.route.snapshot.paramMap, this.params)]);
	}

    delete(uid) {
        this.rest.delete('profile/' + uid, { observe: 'response', responseType: 'text',
				body: {'reason': this.reasonForDeletion.trim() } }).subscribe((res) => {
			if (res.status !== 200) return;
			this.users.some((user, idx) => {
				if (user.id === uid) {
					this.users.splice(idx, 1);
					return true;
				}
			});
        });
    }
}
